import { makeStyles } from '@mui/styles';
import { neutral6 } from 'apollo-react/colors';
import Radio from 'apollo-react/components/Radio';
import RadioGroup from 'apollo-react/components/RadioGroup';
import Typography from 'apollo-react/components/Typography';
import React from 'react';

import { useTranslation } from '../../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  columnTitle: {
    marginBottom: 5,
    color: neutral6,
  },
  radioButtonContainer: {
    flexWrap: 'nowrap',
    maxHeight: 380,
    overflowY: 'auto',
    paddingLeft: 1,
  },
  scrollArrow: {
    border: 'none',
    textAlign: 'center',
    zIndex: 5,
  },
});

export const TopicSection = (props) => {
  const { topicIndex, setTopicIndex, setPage, answerInfo } = props;

  const classes = useStyles();
  const translateString = useTranslation();

  const handleTopicChange = ({ target }) => {
    setTopicIndex(Number(target.value));
    setPage(0);
  };

  return (
    <>
      <Typography className={classes.columnTitle}>{translateString('Topic')}</Typography>
      <RadioGroup
        className={classes.radioButtonContainer}
        value={topicIndex}
        onChange={handleTopicChange}
      >
        {answerInfo.map(({ Title }, index) => (
          <Radio key={index} value={index} label={Title} />
        ))}
      </RadioGroup>
    </>
  );
};
